import React from 'react';
import { getFieldValue, getAssetUrl } from '../../../contentful/mappers';
import './Resources.css';

function Resources({ data, isFirst = false }) {
  if (!data) return null;

  const headline = getFieldValue(data, 'headline');
  const description = getFieldValue(data, 'description');
  const items = getFieldValue(data, 'items') || [];

  const normalizedItems = items
    .filter(Boolean)
    .map((item, index) => {
      const title = getFieldValue(item, 'title') || getFieldValue(item, 'label');
      const summary = getFieldValue(item, 'summary') || getFieldValue(item, 'description');
      const url = getFieldValue(item, 'url');
      const file = getFieldValue(item, 'file');
      const fileUrl = file ? getAssetUrl(file) : null;
      const type = getFieldValue(item, 'type');

      let href = null;
      if ((type === 'file' || (!type && file)) && fileUrl) {
        href = fileUrl;
      } else if ((type === 'link' || (!type && url)) && url) {
        href = url;
      }

      if (!href && !title && !summary) return null;

      return {
        id: item.sys?.id || index,
        title: title || href || 'Resource',
        summary,
        href,
        type: type || (file ? 'file' : 'link'),
      };
    })
    .filter(Boolean);

  if (normalizedItems.length === 0 && !headline && !description) {
    return null;
  }

  return (
    <section className={`resources-section${isFirst ? ' resources-section-first' : ''}`}>
      <div className="container">
        {headline && (
          <h2 className="section-headline resources-headline">
            {headline}
          </h2>
        )}
        {description && (
          <p className="resources-description">
            {description}
          </p>
        )}
        {normalizedItems.length > 0 && (
          <div className="resources-list">
            {normalizedItems.map((item) => {
              const isDownload = item.type === 'file';
              const hasSummary = Boolean(item.summary);
              return (
                <a
                  key={item.id}
                  href={item.href || '#'}
                  className={`resource-item${hasSummary ? ' has-summary' : ' no-summary'}`}
                  target={isDownload ? undefined : '_blank'}
                  rel={isDownload ? undefined : 'noopener noreferrer'}
                  download={isDownload ? '' : undefined}
                >
                  <div className="resource-main">
                    <h3 className="resource-title">
                      {item.title}
                    </h3>
                    {item.summary && (
                      <p className="resource-summary">
                        {item.summary}
                      </p>
                    )}
                  </div>
                  <div className="resource-meta">
                    <span className="resource-type">
                      {isDownload ? 'Download' : 'Open'}
                    </span>
                    <span className="resource-arrow">↗</span>
                  </div>
                </a>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
}

export default Resources;

